var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FieldWrapper',{attrs:{"state":_vm.state,"configs":_vm.configs}},[_c('div',{staticClass:"column full-width q-mt-md"},[_c('q-btn',{attrs:{"dense":"","outline":"","color":"primary","no-caps":"","padding":"6px 6px","icon":"mdi-web","size":"11px","label":_vm.configs.buttonLabel},on:{"click":_vm.openUrl}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }